import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { ConfirmEmailRequestPage } from 'src/app/model/page/group/user/confirm-email-request-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';

@Component({
  selector: 'app-confirm-email-request-page',
  templateUrl: './confirm-email-request-page.component.html',
  styleUrls: ['./confirm-email-request-page.component.scss']
})
export class ConfirmEmailRequestPageComponent implements OnInit {
  confirmEmailRequestPage: ConfirmEmailRequestPage = {} as ConfirmEmailRequestPage;

  constructor(private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    const query = { 'fields.title': 'Confirm Email Request' };
    this.contentfulService.getPageContentWithEntries(query).then((confirmEmailRequestPageEntries) => {
      this.mapBanner(confirmEmailRequestPageEntries);
    });
  }

  private mapBanner(confirmEmailRequestPageEntries: Entry<any>[]) {
    confirmEmailRequestPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.confirmEmailRequestPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }
}
